<template>
    <template v-if="gfFlag != '1'">
        <a
            href="/site/privacy-terms"
            target="_blank"
            style="text-decoration: underline"
            rel="noopener noreferrer"
        >{{ $t('md-footer.privacyPolicyTos') }}</a
        >
    </template>
    <template v-else>
        <a
            href="http://geographicfarm.com/terms-service/"
            style="text-decoration: underline"
            rel="noopener noreferrer"
        >{{ $t('md-footer.terms') }}</a
        >
        |
        <a
            href="http://geographicfarm.com/privacy-policy/"
            style="text-decoration: underline"
            rel="noopener noreferrer"
        >{{ $t('md-footer.privacy') }}</a
        >
    </template>
    |
    <a
        href="/site/privacy-terms#cookie-policy"
        style="text-decoration: underline"
        rel="noopener noreferrer"
    >{{ $t('md-footer.cookiePolicy') }}</a
    >
    |
    <span
        style="text-decoration: underline; cursor: pointer"
        @click="onOpenCookieSetting"
    >{{ $t('md-footer.cookieSettings') }}</span
    >
    |
    <a
        href="/property-listings/sitemap"
        style="text-decoration: underline"
        rel="noopener noreferrer"
    >{{ $t('md-footer.PropertyListings') }}</a
    >
    |
    <a
        href="/sitemap"
        style="text-decoration: underline"
        rel="noopener noreferrer"
    >{{ $t('md-footer.sitemap') }}</a
    >
    <template v-if="isShowAccessibility">
        |
        <a
            href="/accessibility"
            style="text-decoration: underline"
            rel="noopener noreferrer"
        >{{ $t('md-footer.accessibility') }}</a
        >
    </template>
</template>
<script>
import PreferencePop from "@/components/cookieAuthority/theme/PreferencePop";

export default {
    name: 'copy-right-link',
    i18next: {
        ns: 'md-footer'
    },
    props: {
        gfFlag: {

        },
        isShowAccessibility: {

        }
    },
    methods: {
        onOpenCookieSetting() {
            PreferencePop();
        }
    }
};
</script>
